import React, { useState, useEffect, useRef } from "react";
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
import { useDashboard } from "./dashboardStore";

const MistakesTable = () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newItem, setNewItem] = useState({ description: "", type: "Data", frequency: 1, action: "Pending" });


  // Subscribe to dashboard store slice
const mistakesDat = useDashboard(state => state.data?.mistakes);

// -------------------------------------
// Process mistakes requests data
// -------------------------------------
useEffect(() => {
  // Wait until store has data
  if (!mistakesDat) return;

  try {
    // Save to state
        setItems(mistakesDat);
  } catch (err) {
    console.error("Error processing feature requests:", err);
    setItems([]);
  }
}, [mistakesDat]); // Reactive: runs whenever store updates



  // add a new mistake
  const handleAdd = async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/api/mistakes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...newItem,
          date: new Date().toISOString().split("T")[0], // yyyy-mm-dd
        }),
      });

      if (!res.ok) throw new Error("Failed to add mistake");
      const data = await res.json();
      const updatedFlag = res.headers.get("X-Mistake-Updated") === "true";
    
        if (!updatedFlag) {
          // only add new items if it wasn't an update
          setItems([data, ...items]);
        } else {
            setItems(items.map(i => (i.Id === data.Id ? data : i)));
        }

      setShowModal(false);
      setNewItem({ description: "", type: "Data", frequency: 1, action: "Pending" });
    } catch (err) {
      console.error("Error adding mistake:", err);
    }
  };

  // delete a mistake
  const handleDelete = async (id) => {
    const confirm = window.confirm("Are you sure you want to delete this mistake?");
  if (!confirm) return; // user cancelled

  
    try {

      const res = await fetch(`${apiBaseUrl}/api/mistakes/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed to delete mistake");

      setItems(items.filter((i) => i.Id !== id));
    } catch (err) {
      console.error("Error deleting mistake:", err);
    }
  };

const filteredItems = items.filter((i) => {
  const desc = i.description?.toLowerCase() ?? "";
  const type = i.type?.toLowerCase() ?? "";
  return desc.includes(search.toLowerCase()) || type.includes(search.toLowerCase());
});


  return (
    <div className="w-full  p-4">
      {/* Search + Add */}

      <div className="flex flex-col sm:flex-row items-center justify-between mb-4 gap-2">
        <input
          type="text"
          placeholder="Search by description or type..."
          className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-blue-200 flex-1"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer"
          onClick={() => setShowModal(true)}
        >
          Add Mistake
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto rounded-md border border-gray-200">
        <table className="min-w-full divide-y divide-gray-100 text-sm md:text-base">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-4 text-center font-medium text-gray-700">#</th>
              <th className="px-3 py-4 text-center font-medium text-gray-700">Description</th>
              <th className="px-3 py-4 text-center font-medium text-gray-700">Type</th>
              <th className="px-3 py-4 text-center font-medium text-gray-700">Frequency</th>
              <th className="px-3 py-4 text-center font-medium text-gray-700">Date</th>
              <th className="px-3 py-4 text-center font-medium text-gray-700">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filteredItems.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-3 py-4 text-center text-gray-500 italic">
                  No mistakes found
                </td>
              </tr>
            ) : (
            
              filteredItems.map((item, idx) => (
                <tr key={item.Id} className="hover:bg-gray-300 even:bg-gray-200 odd:bg-white">
                  <td className="px-3 py-2 text-center text-gray-600">{idx + 1}</td>
                  <td className="px-3 py-2 text-center font-medium text-gray-800">{item.Description}</td>
                  <td className="px-3 py-2 text-center text-gray-600">{item.Type}</td>
                  <td className="px-3 py-2 text-center text-gray-600">{item.Frequency}</td>
                    <td className="px-3 py-2 text-center text-gray-600">
                      {new Date(item.Date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </td>



                  <td className="px-3 py-2 text-center">
                    <button
                      className="px-2 py-1 text-sm text-white bg-red-600 rounded-md hover:bg-red-700 cursor-pointer"
                      onClick={() => handleDelete(item.Id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Generate AI Insights Button */}
      <div className="flex justify-center mt-10">
        <button
          className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 cursor-pointer"
          onClick={() => alert("Work in progress")}
        >
          Generate AI Insights
        </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg p-6 relative">
            <h2 className="text-lg font-semibold mb-4">Add New Mistake</h2>
            <div className="flex flex-col gap-3">
              <input
                type="text"
                placeholder="Description"
                className="px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                value={newItem.description}
                onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
              />
              <select
                className="px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                value={newItem.type}
                onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
              >
                <option>Data</option>
                <option>Process</option>
                <option>Emotional</option>
                <option>Staff</option>
                <option>System</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                className="px-4 py-2 rounded-md border hover:bg-gray-100 cursor-pointer"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer"
                onClick={handleAdd}
              >
                Add
              </button>
            </div>
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 cursor-pointer"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MistakesTable;
